import {ScreenProp} from 'src/app/models'
import {JobTugasScreen} from '../page/Job/Screen'
import {PersetujuanTugasScreen} from '../page/PersetujuanTugas/Screen'

type TJobTugasKeys = keyof typeof JobTugasScreen
type TPersetujuanTugasKeys = keyof typeof PersetujuanTugasScreen

type TKeys = 'JOB' | TJobTugasKeys | TPersetujuanTugasKeys

const JobScreens: Record<TKeys, ScreenProp> = {
  JOB: {
    PATH: '/job',
    TITLE: 'Manajemen Tugas',
    TITLE_ALT: 'Tugas ke Agen',
  },

  ...JobTugasScreen,
  ...PersetujuanTugasScreen,
}

export default JobScreens
